export default "__VITE_PUBLIC_ASSET__c21b372a__"